module.exports = __webpack_public_path__ + "static/img/17.2e8d818a.png";